import { render, staticRenderFns } from "./CouponUpdate.vue?vue&type=template&id=82002e5a"
import script from "./CouponUpdate.vue?vue&type=script&lang=js"
export * from "./CouponUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports